import {
  IHinhThucChiTiet,
  IHinhThucMienGiamChiTietViewModel,
} from "../../../model/respone/mien-giam/IHinhThucChiTiet";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHinhThucChiTietActionsObj = {
  LOAD_START: {} as number,
  LOAD_SUCCESS: {} as IHinhThucMienGiamChiTietViewModel[],
  LOAD_ERRR: "",

  SAVE_START: {} as IHinhThucChiTiet,
  SAVE_SUCCESS: {} as IHinhThucChiTiet,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IHinhThucMienGiamChiTietViewModel,
  CLOSE_EDIT_MODAL: undefined,

  CHANGE_IDHINHTHUC: 0,
};
export const eHinhThucChiTietActionIds = generateActionTypeIds(
  eHinhThucChiTietActionsObj,
  "HINH_THUC_MIEN_GIAM_CHI_TIET"
);
export type IHinhThucChiTietActionTypes = IGenericActionType<
  typeof eHinhThucChiTietActionsObj,
  "HINH_THUC_MIEN_GIAM_CHI_TIET"
>;
